export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filtry"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sklep"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Konto"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zastosuj"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wyczyść wszystko"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wybierz status"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wybierz sklep"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wprowadź numer faktury"])}
}